import React from 'react';
import '../../assets/lineawesome/css/line-awesome.min.css';

const LineAwesome = ({ icon, size, className, iconStyle, ...restOfProps }: LineAwesomeProps) => {
  if (!icon) return null;
  const iconValue = icon.match(/^la-/) ? ` ${icon}` : ` la-${icon}`;
  const totalSize = size ? ` la-${size}` : '';
  const styleVariant = iconStyle ? ` ${iconStyle}` : ' las';
  const cName = className ? `${className} ` : '';
  return <i {...restOfProps} className={`${cName}${styleVariant}${iconValue}${totalSize}`} />;
};

export default LineAwesome;

export interface LineAwesomeProps {
  icon: string;
  size?:
    | 'lg'
    | 'xs'
    | 'sm'
    | 'lx'
    | '1x'
    | '2x'
    | '3x'
    | '4x'
    | '5x'
    | '6x'
    | '7x'
    | '8x'
    | '9x'
    | '10x'
    | 'fw';
  className?: string;
  iconStyle?: 'lar' | 'las' | 'lab' | 'la';
  style?: React.CSSProperties;
  title?: string;
  onClick?: (event: React.MouseEvent<HTMLSpanElement>) => void;
  role?: string;
}
